export enum CharacterBubbleAnimation {
  SHAKE = 'shake',
  APPEAR = 'appear',
  POP = 'pop',
  REDUCE = 'reduce',
}
